export default {"src":"/_next/static/media/face-enhance.3bd819e8.svg","height":36,"width":36};